export default {
  close: 'Close'
}
